"use client"

import {headerConfig as config} from "~/config/layout/header"
import Nav from "./ui/header"
import HeaderUI from "./ui/header";

export default function Header() {
  return (
    <HeaderUI>
      <HeaderUI.Toolbar>
        <HeaderUI.Links>
          {config.nav_links.map((item, index) => (
            <Nav.LinkItem key={index} label={item.label} link={item.href}  />
          ))}
        </HeaderUI.Links>
        <HeaderUI.MenuBar />
      </HeaderUI.Toolbar>
      <HeaderUI.MobileMenu>
        {config.nav_links.map((item, index) => (
          <Nav.MobileMenuItem key={index} label={item.label} link={item.href}  />
        ))}
      </HeaderUI.MobileMenu>
    </HeaderUI>
  )
}
